import React from 'react'
import { Dialog, Button, Table, TableCell, TableContainer, TableHead, TableRow, TableBody, DialogContent } from '@material-ui/core'
import { useStyles } from './styles'

const DialogMaterials = ({ open, onClose, materialsInfo }) => {
  const classes = useStyles()
  const handleClose = () => onClose(false, false)

  return (
    <Dialog onClose={handleClose} open={open} className={materialsInfo.length === 0 ? classes.simpleContainer : classes.container} fullWidth>
      {materialsInfo.length > 0 ?
        <>
          <TableContainer className={classes.tableContainer}>
            <Table>
              <TableHead>
                <Button onClick={handleClose} className={classes.btnClose}>X</Button>
                <TableRow>
                  <TableCell>Material</TableCell>
                  <TableCell>Vertical</TableCell>
                  <TableCell>Tipo de material</TableCell>
                  <TableCell>Clasificación</TableCell>
                  <TableCell>Categoría</TableCell>
                  <TableCell>Subcategoría</TableCell>
                  <TableCell>Marca</TableCell>
                  <TableCell>Estado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {materialsInfo.map(mat => (
                  <TableRow key={mat.Material}>
                    <TableCell>{mat.Material}</TableCell>
                    <TableCell>{mat.VERTICAL}</TableCell>
                    <TableCell>{mat.Tipo_Material}</TableCell>
                    <TableCell>{mat.Clasificacion}</TableCell>
                    <TableCell>{mat.Categoria}</TableCell>
                    <TableCell>{mat.Sub_Categoria}</TableCell>
                    <TableCell>{mat.Marca}</TableCell>
                    <TableCell>{mat.Estado_ITEM}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </> : <DialogContent className={classes.dialogContent}>No hay información disponible</DialogContent>
      }
    </Dialog>
  )
}

export default DialogMaterials